import React from 'react';
import PropTypes from 'prop-types';
import {
  Panel
 } from 'react-bootstrap';
import Select from 'react-select';

const JNInitWizardPageThree = (props) => {
  const { merge_options, handleChangeMergeDomSet } = props;
  const dominant_set_options = [
    { value : 'ht', label : 'Hail Trace' },
    { value : 'jn', label : 'Job Nimbus' }
  ];

  if(merge_options) {
    return (
      <div className='jn-init-wizard-pg-two-container'>
        <h4>Choose a Dominant Set :</h4>
        <Panel>
          <p>
            Since you are merging two sets of data together, you need to choose a <i>dominant set</i>{' '}
            between your Hail Trace and Job Nimbus accounts. This will be the data that is dominant in the case{' '}
            that a collision is found between your accounts.
          </p>
          <p>
            For example : <br />
            Say you have a client in your Hail Trace account with the following properties :
          </p>
          <p>
            <i>
              Name : Dave Smith<br />
              email : davesmith@masterroofers.com
            </i>
          </p>
          <p>And let's say you've saved the following contact in your Job Nimbus account :</p>
          <p>
            <i>
              First Name : David<br />
              Last Name : Smith<br />
              email : davesmith@masterroofers.com
            </i>
          </p>
          <p>
            If you chose <i>email</i> to be your key, these two entries would be viewed as the same person,{' '}
            so you would need to choose which data set to dominate. In this case, if you had chosen Hail Trace to {' '}
            be the dominant data set, your Job Nimbus account would be updated, and this contact would be saved as <i>Dave Smith</i>.{' '}
            This cannot be done on a client-by-client basis; you will choose either Hail Trace or Job Nimbus, and that set will{' '}
            be the stored data in both accounts for every entry where a collision is found.
          </p>
          <hr className='dotted short' />
          <Select
            options={dominant_set_options}
            value={merge_options.dominant_set || null}
            placeholder='Choose an option'
            onChange={handleChangeMergeDomSet}
          />
        </Panel>
      </div>
    );
  }
  else {
    return <div />
  }
}

export default JNInitWizardPageThree;



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jn-init-wizard-pg-three.js